<template>
  <div
    v-if="HorizontalBannerData?.length > 0"
    class="horizontal-menu mb32 pr0 col-sm-12 pl0 carousel-pr-12"
    id="undefined-horizontal-banner-with-text"
    :counterTextObserver="productObserver"
  >
    <!-- without carousel -->
    <template v-if="isGridViewVariant">
      <h3 class="card-catg-name mb16">What are you craving for?</h3>
      <ul class="grid-view">
        <li v-for="(offer, index) in HorizontalBannerData" :key="index">
          <div
            class="flex-column flex-wrap cursor-pointer"
            :class="{
              disabled:
                getBottomBarData[offer?.title]?.data &&
                Object.keys(
                  getBottomBarData[
                    (offer?.title || '').trim().replace('\n', ' ')
                  ]?.data
                )?.length == 0,
            }"
            @click="
              goto(
                offer,
                index,
                (getBottomBarData[
                  (offer?.title || '').trim().replace('\n', ' ')
                ]?.data &&
                  Object.keys(
                    getBottomBarData[
                      (offer?.title || '').trim().replace('\n', ' ')
                    ]?.data
                  )?.length) ||
                  -1
              )
            "
          >
            <div class="menu-img-wrap">
              <template v-if="offer?.categoryImages?.length > 0">
                <lazy-image
                  class="horizontal-item flex-row img-category-menu"
                  alt="default image"
                  :src="
                    Utility.getProductImages(
                      offer?.categoryImages,
                      'CategoriesV1'
                    )
                  "
                  :src-placeholder="
                    staticImgBaseUrl +
                    '/images/global/default-product-img-lg.png'
                  "
                />
              </template>
              <template v-else>
                <lazy-image
                  class="horizontal-item flex-row img-category-menu-fallback"
                  alt="offer image"
                  :src="offer?.imageUrl + Utility.getSitePropsVersion()"
                  :src-placeholder="
                    staticImgBaseUrl +
                    '/images/global/default-product-img-lg.png'
                  "
                />
              </template>
            </div>
            <span class="fs-11 color-slaty bold mt10 tc">{{
              offer?.title
            }}</span>
          </div>
        </li>
      </ul>
    </template>

    <!-- with carousel -->
    <template v-else>
      <Carousel
        :pauseAutoplayOnHover="true"
        :transition="500"
        :itemsToShow="itemsToShow"
      >
        <Slide v-for="(offer, index) in HorizontalBannerData" :key="index">
          <div
            class="flex-column flex-wrap cursor-pointer"
            @touchstart.stop
            @touchmove.stop
            :class="{
              disabled:
                getBottomBarData[(offer?.title || '').trim().replace('\n', ' ')]
                  ?.data &&
                Object.keys(
                  getBottomBarData[
                    (offer?.title || '').trim().replace('\n', ' ')
                  ]?.data
                )?.length == 0,
            }"
            @click="
              goto(
                offer,
                index,
                (getBottomBarData[
                  (offer?.title || '').trim().replace('\n', ' ')
                ]?.data &&
                  Object.keys(
                    getBottomBarData[
                      (offer?.title || '').trim().replace('\n', ' ')
                    ]?.data
                  )?.length) ||
                  -1
              )
            "
          >
            <div class="menu-img-wrap">
              <template v-if="offer?.categoryImages?.length > 0">
                <lazy-image
                  class="horizontal-item flex-row img-category-menu"
                  alt="default image"
                  :src="
                    Utility.getProductImages(
                      offer?.categoryImages,
                      'CategoriesV1'
                    )
                  "
                  :src-placeholder="
                    staticImgBaseUrl +
                    '/images/global/default-product-img-lg.png'
                  "
                />
              </template>
              <template v-else>
                <lazy-image
                  class="horizontal-item flex-row img-category-menu-fallback"
                  alt="offer image"
                  :src="offer?.imageUrl + Utility.getSitePropsVersion()"
                  :src-placeholder="
                    staticImgBaseUrl +
                    '/images/global/default-product-img-lg.png'
                  "
                />
              </template>
            </div>
            <span class="fs-11 color-slaty bold mt10">{{ offer?.title }}</span>
          </div>
        </Slide>
        <template #addons> </template>
      </Carousel>
    </template>

    <!-- with vieaw all category -->
    <template v-if="isViewAllCategoryVariant">
      <div class="plr12 tc fs-14 bold mt24">
        <div
          class="tag-bg-white pTB10 disp-col-inline justify-content-center"
          @click="triggerNewMenuModal()"
        >
          <span
            class="menu-anchor-full-menu fs-13 flex-row justify-content-center mr12"
          >
            <i aria-hidden="true" class="jfi-list-view"></i>
          </span>
          Full Menu
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { keyMapsMutation } from "../helpers/storeKeys";
import {
  v2PwaBasePath,
  imgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import UserActivityTracking from "../helpers/UserActivityTracking";
import localStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";

export default {
  name: "HorizontalBannerWithText",
  components: {
    Carousel,
    Slide,
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      HorizontalBannerData: [],
      modulePropsData: {},
      itemsToShow: 1,
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      eleIdToObserve: "undefined-horizontal-banner-with-text",
    };
  },
  mounted() {
    this.HorizontalBannerData =
      typeof this.dataResults != null &&
      typeof this.dataResults != "null" &&
      typeof this.dataResults != "undefined"
        ? JSON.parse(this.dataResults)
        : [];
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.itemsToShow = +this.modulePropsData?.itemsInScreen;
    //Amplitude impression event load
    const eventObj = Utility.amplitudeEventObj(
      "impression",
      "explore menu section",
      "5",
      {
        category: this.HorizontalBannerData?.map((_) => {
          return _.title?.toLowerCase();
        }),
      }
    );
    setEvents("amplitude", "Impression", eventObj);

    if (
      this.productObserver &&
      this.eleIdToObserve &&
      document.getElementById(this.eleIdToObserve)
    ) {
      this.productObserver.observe(
        document.getElementById(this.eleIdToObserve)
      );
    }
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.eleIdToObserve));
    }
    if (this.isViewAllCategoryVariant) {
      window.removeEventListener("scroll", this.watchProductCounterString);
    }
  },
  methods: {
    goto(item, index, count) {
      //Amplitude click event load
      UserActivityTracking.category(0, item.title);
      const preEventObj = {
        positionWithinSection: index + 1,
        category: item?.title?.toLowerCase(),
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "explore menu section",
        "5",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
      setEvents("moengage", 'Menu', {
        'Category Selected': item?.title?.toLowerCase(),
        'Screen Name': 'Home Page Menu',
      });

      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME
      ) {
        let url =
          projectBasePathWithFolder +
          "/menu/" +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = this.scrollToCategoryId(item, url);
        window.location.href = url;
      } else {
        if (!count) return;

        this.$store.commit(keyMapsMutation.TRIGGER_FILTER_REF, {});
        let itmId = item?.links[0].href;
        if (itmId) {
          let scrollTopMargin = 70; //default
          if (this.isAnchorLinkVariant) {
            scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
          }
          setTimeout(() => {
            Utility.scrollUptoTo("element_catg_" + itmId, scrollTopMargin);
            this.$store.commit(keyMapsMutation.OPEN_ALL_CARDS, true);
          }, 0);
        }
      }
    },
    eventFunction(isClicked = false, preEventObj = {}) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["sectionName"] ? preEventObj["sectionName"] : "bottom menu",
        "-1",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    triggerNewMenuModal() {
      let menuArray = [];
      menuArray = Object.keys(this.getBottomBarData).map((item) =>
        item.toLowerCase()
      );

      //Amplitude click event load
      this.eventFunction(true, {
        positionWithinSection: "",
        sectionName: "full menu home",
        category: "full menu home",
      });

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_NEW_MENU_MODAL_FLAG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_MENU_MODAL_FLAG_OPENED_FROM,
        "all categories"
      );

      //Amplitude impression event load
      this.eventFunction(false, {
        sectionName: "full menu home",
        subSection: "full menu home",
        menuCategories: menuArray,
        menuCount: menuArray?.length,
      });
      UserActivityTracking.menuOpen(0);
    },
    scrollToCategoryId(item, url) {
      if (item) {
        const category = item?.links?.[0];
        const categoryId = category?.href || "menuTop";
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
    watchProductCounterString() {
      if (
        window.pageYOffset < 50 &&
        !this.productCounterString.startsWith("undefined")
      ) {
        this.$store.commit(
          keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
          "undefined"
        );
      }
    },
  },
  computed: {
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    isGridViewVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === "nextgen_variant_e" ||
        variant === "nextgen_variant_u" ||
        variant === "nextgen_variant_w" ||
        variant === "nextgen_variant_x" ||
        variant === "nextgen_variant_y"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewAllCategoryVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_T
      ) {
        window.addEventListener("scroll", () => {
          this.watchProductCounterString();
        });
        return true;
      } else {
        return false;
      }
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.eleIdToObserve &&
        document.getElementById(this.eleIdToObserve)
      ) {
        observer.observe(document.getElementById(this.eleIdToObserve));
      }
      return observer;
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
  },
};
</script>

<style lang="scss" scoped></style>
